<template>
  <div class="grid gap-0.5 rounded px-3 py-2 border border-yellow-700/20 bg-yellow-50/60">
    <p class="font-medium" v-if="heading">{{ heading }}</p>
    <p class="text-sm" v-if="description">{{ description }}</p>
  </div>
</template>

<script setup>

const props = defineProps({
  heading: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  }
})
</script>